import { atom, useAtom } from 'jotai';
import { useFilterConditionAtom } from '@/features/analyze/atoms/filterCondition.atom';

const TagViewDialogAtom = atom<boolean>(false);

const savedQueryAtom = atom<string>('');

export const useTagViewDialog = () => {
  const [isOpen, setIsOpen] = useAtom(TagViewDialogAtom);
  const [savedQuery, setSavedQuery] = useAtom(savedQueryAtom);
  const [filterCondition, setFilterCondition] = useFilterConditionAtom();

  const open = () => {
    setSavedQuery(filterCondition.query ?? '');
    setIsOpen(true);
  };

  const close = () => {
    setFilterCondition((prev) => ({
      ...prev,
      query: savedQuery,
    }));
    setIsOpen(false);
  };

  return { isOpen, open, close };
};
